// extracted by mini-css-extract-plugin
module.exports = {"tabs":"styles_tabs__OeHfr","tabsWrapper":"styles_tabsWrapper__2H3Dx","tab":"styles_tab__1rFIS","selected":"styles_selected__1XvSa","underBar":"styles_underBar__2FIM_"};